import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollUpdateDraftEmployeeCompensationStepInput,
  PayrollUpdateDraftEmployeeCompensationGraphQLRequest,
  PayrollUpdateDraftEmployeeCompensationStepResponse,
} from '../types';

const payrollUpdateDraftEmployeeCompensationMutation = gql`
  mutation PayrollUpdateDraftEmployeeCompensation(
    $draftEmployeeId: Int!
    $input: PayrollUpdateDraftEmployeeCompensationStepInput!
  ) {
    payrollUpdateDraftEmployeeCompensation(draftEmployeeId: $draftEmployeeId, input: $input) {
      code
      success
      message
      data {
        id
      }
    }
  }
`;

export const updateDraftEmployeeCompensationStep = (payload: {
  draftEmployeeId: number;
  input: PayrollUpdateDraftEmployeeCompensationStepInput;
}) => {
  return graphQLApi<
  PayrollUpdateDraftEmployeeCompensationStepResponse,
    PayrollUpdateDraftEmployeeCompensationGraphQLRequest
  >({
    query: payrollUpdateDraftEmployeeCompensationMutation,
    queryVariables: payload,
  });
};
